import { Link, useNavigate, Outlet, useLocation } from "react-router-dom";
import { LayoutDashboard, PlusCircle, LogOut, ExternalLink, ImagePlus, ShieldCheck } from "lucide-react";
import GlobalSearch from "@/pages/admin/GlobalSearch";

export default function AdminLayout() {
  const nav = useNavigate();
  const loc = useLocation();
  const admin = (() => { try { return JSON.parse(localStorage.getItem("admin_user") || "null"); } catch { return null; } })();

  const logout = () => {
    localStorage.removeItem("admin_token");
    localStorage.removeItem("admin_user");
    nav("/adminia/login");
  };

  const isActive = (p) => loc.pathname === p || (p !== "/adminia" && loc.pathname.startsWith(p));

  return (
    <div className="min-h-screen bg-slate-50 text-navy">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-4 md:px-8">
          <Link to="/adminia" className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-navy font-heading text-sm font-bold text-white">AA</span>
            <span className="flex flex-col leading-tight">
              <span className="font-heading text-sm font-bold">Executive Insights</span>
              <span className="font-body text-xs text-slate-500">Admin</span>
            </span>
          </Link>
          <nav className="hidden items-center gap-2 md:flex">
            <Link to="/adminia" data-testid="admin-nav-dashboard" className={`inline-flex items-center gap-2 rounded-full px-4 py-2 font-body text-sm ${isActive("/adminia") && !isActive("/adminia/blogs/new") ? "bg-navy text-white" : "text-slate-600 hover:text-navy"}`}>
              <LayoutDashboard className="h-4 w-4" /> Dashboard
            </Link>
            <Link to="/adminia/blogs/new" data-testid="admin-nav-new" className={`inline-flex items-center gap-2 rounded-full px-4 py-2 font-body text-sm ${isActive("/adminia/blogs/new") ? "bg-navy text-white" : "text-slate-600 hover:text-navy"}`}>
              <PlusCircle className="h-4 w-4" /> New Article
            </Link>
            <Link to="/adminia/media" data-testid="admin-nav-media" className={`inline-flex items-center gap-2 rounded-full px-4 py-2 font-body text-sm ${isActive("/adminia/media") ? "bg-navy text-white" : "text-slate-600 hover:text-navy"}`}>
              <ImagePlus className="h-4 w-4" /> Media
            </Link>
            <Link to="/adminia/security" data-testid="admin-nav-security" className={`inline-flex items-center gap-2 rounded-full px-4 py-2 font-body text-sm ${isActive("/adminia/security") ? "bg-navy text-white" : "text-slate-600 hover:text-navy"}`}>
              <ShieldCheck className="h-4 w-4" /> Security
            </Link>
            <Link to="/insights" target="_blank" className="inline-flex items-center gap-2 rounded-full px-4 py-2 font-body text-sm text-slate-600 hover:text-navy">
              View site <ExternalLink className="h-3.5 w-3.5" />
            </Link>
          </nav>
          <div className="flex items-center gap-3">
            <GlobalSearch />
            <div className="hidden text-right md:block">
              <p className="font-body text-xs text-slate-500">Signed in as</p>
              <p className="font-heading text-sm font-semibold">{admin?.email || "admin"}</p>
            </div>
            <button onClick={logout} data-testid="admin-logout" className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 font-body text-sm text-slate-600 hover:border-navy hover:text-navy">
              <LogOut className="h-4 w-4" /> Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-[1400px] px-6 py-10 md:px-8"><Outlet /></main>
    </div>
  );
}
